// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/keyboard.js';

import { paths } from '../generated/keyboard';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('keyboard', Original, paths);
